var npdiFactory = function ($resource, $window) {
  var validatePPTDataWithNPDIPostApi =
    "rest/nonauth/npdi/validatePPTDataWithNPDI";
  var retrieveContactDetailsDropdown =
    "rest/nonauth/npdi/retrieveContactDetailsDropdown";
  var retrieveDropdownValuesOnNpdiPageLoadApi =
    "rest/nonauth/npdi/retrieveDropdownValuesOnNpdiPageLoad";
  var retrievePlansToLinkApi = "rest/nonauth/npdi/npdiLinkedPlans";
  var addNPDIpptPostApi = "rest/nonauth/npdi/addNPDIPPTEnroll";
  var updNPDIPPTEnrollApi = "rest/nonauth/npdi/updNPDIPPTEnroll";
  var isPECKTMGEnabled = "rest/nonauth/npdi/isPECKTMGEnabled";

  return {
    validatePPTDataWithNPDI: $resource(
      __authenticationUrl__ + validatePPTDataWithNPDIPostApi,
      {},
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
            requestSrc: "empower_browser",
          },
        },
      }
    ),
    retrieveContactDetailsDropdown: $resource(
      __authenticationUrl__ + retrieveContactDetailsDropdown,
      {},
      {
        query: {
          method: "GET",
          isArray: false
        },
      }
    ),
    retrieveDropdownValuesOnNpdiPageLoad: $resource(
      __authenticationUrl__ + retrieveDropdownValuesOnNpdiPageLoadApi,
      {},
      {
        query: {
          method: "GET",
          isArray: false
        },
      }
    ),
    addNPDIppt: $resource(
      __authenticationUrl__ + addNPDIpptPostApi,
      {},
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),
    retrievePlansToLink: $resource(
      __authenticationUrl__ + retrievePlansToLinkApi,
      {},
      {
        query: {
          method: "GET",
          isArray: false
        },
      }
    ),

    isPECKTMGEnabled: $resource(
      __authenticationUrl__ + isPECKTMGEnabled,
      {},
      {
        query: {
          method: "GET",
          isArray: false
        },
      }
    ),

    updNPDIPPTEnroll: $resource(
      __authenticationUrl__ + updNPDIPPTEnrollApi,
      {},
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),
  };
};

npdiFactory.$inject = ["$resource", "$window"];
export default npdiFactory;